import { WelcomeWebComponent } from './component/WelcomeWebComponent';

export { WelcomeWebComponent };
